import React, { useRef } from 'react';
import { Button, Card, Container, FloatingLabel, Form } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';

const CheckOut = () => {
    const email = useRef();
    const password = useRef();
    
    const handleSubmit = (e)=>{
        e.preventDefault();
        if(email && password){
            toast.success('Thank you for the booking.')
        }else{
            toast.error('Please Fill Up The Form First')
        }
    }
    return (
        <Container style={{minHeight:'90vh'}} className='d-flex align-items-center justify-content-center'>
            <div className='w-100' style={{maxWidth:'600px'}}>
                    <Card style={{maxWidth:'450px'}} className='p-2 mx-auto'>
                        <Card.Body>
                            <Card.Title>
                                <h3>CheckOut</h3>
                            </Card.Title>
                            <Form onSubmit={handleSubmit} className='my-5'>
                                <FloatingLabel
                                    controlId="formBasicEmail"
                                    label="Email address"
                                    className="mb-3"
                                >
                                    <Form.Control ref={email} type="email" placeholder="name@example.com" />
                                </FloatingLabel>
                                <FloatingLabel
                                    controlId="formBasicPassword"
                                    label="Password"
                                    className="mb-3"
                                >
                                    <Form.Control ref={password} type="password" placeholder="Password" />
                                </FloatingLabel>
                                <Button variant="primary" type="submit" className='w-100 fs-5 fw-bold'>Check Out</Button>
                            </Form> 
                        </Card.Body>
                    </Card>
            </div>
            <ToastContainer />
        </Container>
    );
};

export default CheckOut;